/**
 * Generate blur placeholder for images
 */

// Base64 blur placeholder (1x1 pixel)
export const generateBlurPlaceholder = (width = 8, height = 8): string => {
  // Create a simple gradient blur placeholder
  return `data:image/svg+xml;base64,${Buffer.from(
    `<svg width="${width}" height="${height}" viewBox="0 0 ${width} ${height}" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:#f3f4f6;stop-opacity:1" />
          <stop offset="50%" style="stop-color:#e5e7eb;stop-opacity:1" />
          <stop offset="100%" style="stop-color:#f9fafb;stop-opacity:1" />
        </linearGradient>
      </defs>
      <rect width="100%" height="100%" fill="url(#gradient)" />
    </svg>`
  ).toString('base64')}`;
};

// Colored blur placeholder for different image types
export const generateColoredBlurPlaceholder = (color = '#f3f4f6'): string => {
  return `data:image/svg+xml;base64,${Buffer.from(
    `<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="100%" height="100%" fill="${color}" opacity="0.3" />
    </svg>`
  ).toString('base64')}`;
};

// Common blur placeholders for different use cases
export const blurPlaceholders = {
  default: generateBlurPlaceholder(),
  hero: generateColoredBlurPlaceholder('#8b5cf6'), // violet
  avatar: generateColoredBlurPlaceholder('#10b981'), // emerald
  portfolio: generateColoredBlurPlaceholder('#3b82f6'), // blue
  blog: generateColoredBlurPlaceholder('#f59e0b'), // amber
} as const;

// Dynamic blur placeholder based on image dimensions
export const getOptimalBlurPlaceholder = (width?: number, height?: number): string => {
  if (!width || !height) return blurPlaceholders.default;
  
  // Use smaller dimensions for blur placeholder
  const blurWidth = Math.min(Math.max(width / 10, 4), 40);
  const blurHeight = Math.min(Math.max(height / 10, 4), 40);
  
  return generateBlurPlaceholder(blurWidth, blurHeight);
};